<template>
  <div align="center">
    <v-dialog ref="dialog" v-model="modal2" persistent max-width="1500px">
      <template v-slot:activator="{ props }">
        <v-btn
          :color="guardado ? 'green' : 'red-darken-4'"
          dark
          prepend-icon="mdi-map-marker-plus"
          size="x-large"
          v-bind="props"
        >
          Dirección:
        </v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="red-darken-4">
          <v-btn icon dark @click="modal2 = false">
            <v-icon>mdi-close </v-icon>
          </v-btn>
          <v-toolbar-title
            ><v-icon left>mdi-map-marker-plus</v-icon> Dirección
            {{ this.Direccion }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn class="d-none d-md-block" @click="Guardar()" dark text
              >Guardar</v-btn
            >
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-row align="center" justify="start">
            <!--Vía Principal -->
            <v-col cols="12" sm="12" md="12">
              <div class="text-center">
                <v-chip
                  label
                  color="primary"
                  text-color="white"
                  value="Vía Principal"
                >
                  <v-avatar left>
                    <v-icon>mdi-map</v-icon>
                  </v-avatar>
                  <b> VÍA PRINCIPAL </b>
                </v-chip>
              </div>
            </v-col>
            <!--Prefijo-->
            <v-col cols="12" sm="12" md="2">
              <v-tooltip location="top" color="primary">
                <template v-slot:activator="{ props }">
                  <v-autocomplete
                    v-model="dataInfo.TipoViaPrincipal"
                    :items="ArrayPrefijo"
                    item-value="Valor"
                    item-title="Descripcion"
                    color="primary"
                    clearable
                    dense
                    label="Prefijo:"
                    :hint="'Elija uno de los prefijos de la dirección:'"
                    v-bind="props"
                  >
                  </v-autocomplete>
                </template>
                <span>Cra. - Carrera</span>
              </v-tooltip>
            </v-col>
            <!--Numero-->
            <v-col cols="12" sm="12" md="2">
              <v-tooltip location="top" color="primary">
                <template v-slot:activator="{ props }">
                  <v-text-field
                    v-model="dataInfo.NumeroViaPrincipal"
                    type="tel"
                    v-on:keypress="isNumber()"
                    color="primary"
                    :maxlength="4"
                    :counter="4"
                    clearable
                    dense
                    label="Número:"
                    :hint="'Ingrese solo números:'"
                    v-bind="props"
                  >
                  </v-text-field>
                </template>
                <span>84</span>
              </v-tooltip>
            </v-col>
            <!--Letra -->
            <v-col cols="12" sm="12" md="2">
              <v-tooltip location="top" color="primary">
                <template v-slot:activator="{ props }">
                  <v-text-field
                    v-model="dataInfo.ModificadorViaPrincipal"
                    color="primary"
                    :maxlength="4"
                    :counter="4"
                    clearable
                    dense
                    label="Letra:"
                    :hint="'Ingrese solo letras:'"
                    v-bind="props"
                  >
                  </v-text-field>
                </template>
                <span>B</span>
              </v-tooltip>
            </v-col>
            <!--Característica Dirección-->
            <v-col cols="12" sm="12" md="2">
              <v-tooltip location="top" color="primary">
                <template v-slot:activator="{ props }">
                  <v-autocomplete
                    v-model="dataInfo.PrefijoViaPrincipal"
                    :items="ArrayBis"
                    item-value="Valor"
                    item-title="Descripcion"
                    color="primary"
                    clearable
                    dense
                    label="Caracteristica dirección:"
                    :hint="'Elija uno de los prefijos de la dirección:'"
                    v-bind="props"
                  >
                  </v-autocomplete>
                </template>
                <span>Bis</span>
              </v-tooltip>
            </v-col>
            <!--Letra 2 -->
            <v-col cols="12" sm="12" md="2">
              <v-tooltip location="top" color="primary">
                <template v-slot:activator="{ props }">
                  <v-text-field
                    v-model="modelSelected.letra2"
                    color="primary"
                    :maxlength="4"
                    :counter="4"
                    clearable
                    dense
                    label="Letra:"
                    :hint="'Ingrese solo letras:'"
                    v-bind="props"
                  >
                  </v-text-field>
                </template>
                <span>C</span>
              </v-tooltip>
            </v-col>
            <!--Orientación Geográfica-->
            <v-col cols="12" sm="12" md="2">
              <v-tooltip location="top" color="primary">
                <template v-slot:activator="{ props }">
                  <v-autocomplete
                    v-model="modelSelected.orientacion"
                    :items="ArrayOrientacion"
                    item-value="Valor"
                    item-title="Descripcion"
                    color="primary"
                    clearable
                    dense
                    label="Orientación Geográfica:"
                    :hint="'Elija uno de las orientaciones de la dirección:'"
                    v-bind="props"
                  >
                  </v-autocomplete>
                </template>
                <span>Bis</span>
              </v-tooltip>
            </v-col>
            <!--Vía Secundaria -->
            <v-col cols="12" sm="12" md="6">
              <div class="text-center">
                <v-chip
                  label
                  color="#B6332E"
                  text-color="white"
                  value="Vía Principal"
                >
                  <v-avatar left>
                    <v-icon>mdi-map</v-icon>
                  </v-avatar>
                  <b> VÍA SECUNDARIA </b>
                </v-chip>
              </div>
            </v-col>
            <!--Vía Complemtento -->
            <v-col cols="12" sm="12" md="6">
              <div class="text-center">
                <v-chip
                  label
                  color="#B6332E"
                  text-color="white"
                  value="Vía Principal"
                >
                  <v-avatar left>
                    <v-icon>mdi-map</v-icon>
                  </v-avatar>
                  <b> VÍA COMPLEMENTO </b>
                </v-chip>
              </div>
            </v-col>
            <!--# -->
            <v-col cols="12" sm="12" md="2" justify="center">
              <div class="text-center">
                <b class="text-h5 mb-1"> # </b>
              </div>
            </v-col>
            <!--Numero 2-->
            <v-col cols="12" sm="12" md="2">
              <v-tooltip location="top" color="primary">
                <template v-slot:activator="{ props }">
                  <v-text-field
                    v-model="dataInfo.NumeroVia"
                    type="tel"
                    v-on:keypress="isNumber()"
                    color="primary"
                    :maxlength="4"
                    :counter="4"
                    clearable
                    dense
                    label="Número:"
                    :hint="'Ingrese solo números:'"
                    v-bind="props"
                  >
                  </v-text-field>
                </template>
                <span>55</span>
              </v-tooltip>
            </v-col>
            <!--Letra 3 -->
            <v-col cols="12" sm="12" md="2">
              <v-tooltip location="top" color="primary">
                <template v-slot:activator="{ props }">
                  <v-text-field
                    v-model="dataInfo.ModificadorVia"
                    color="primary"
                    :maxlength="4"
                    :counter="4"
                    clearable
                    dense
                    label="Letra:"
                    :hint="'Ingrese solo letras:'"
                    v-bind="props"
                  >
                  </v-text-field>
                </template>
                <span>BA</span>
              </v-tooltip>
            </v-col>
            <!-- - -->
            <v-col cols="12" sm="12" md="2" justify="center">
              <div class="text-center">
                <b class="text-h5 mb-1"> --- </b>
              </div>
            </v-col>
            <!--Numero 3 -->
            <v-col cols="12" sm="12" md="2">
              <v-tooltip location="top" color="primary">
                <template v-slot:activator="{ props }">
                  <v-text-field
                    v-model="dataInfo.NumeroPLaca"
                    type="tel"
                    v-on:keypress="isNumber()"
                    color="primary"
                    :maxlength="4"
                    :counter="4"
                    clearable
                    dense
                    label="Número:"
                    :hint="'Ingrese solo números:'"
                    v-bind="props"
                  >
                  </v-text-field>
                </template>
                <span>15</span>
              </v-tooltip>
            </v-col>
            <!--Orientación Geográfica 2-->
            <v-col cols="12" sm="12" md="2">
              <v-tooltip location="top" color="primary">
                <template v-slot:activator="{ props }">
                  <v-autocomplete
                    v-model="dataInfo.PrefijoViaGeneradora"
                    :items="ArrayOrientacion"
                    item-value="Valor"
                    item-title="Descripcion"
                    color="primary"
                    clearable
                    dense
                    label="Orientación Geográfica:"
                    :hint="'Elija uno de las orientaciones de la dirección:'"
                    v-bind="props"
                  >
                  </v-autocomplete>
                </template>
                <span>Occidente</span>
              </v-tooltip>
            </v-col>
            <!--Adicional Dirección -->
            <v-col cols="12" sm="12" md="12">
              <v-tooltip location="top" color="primary">
                <template v-slot:activator="{ props }">
                  <v-text-field
                    v-model="modelSelected.adicional"
                    type="tel"
                    v-on:keypress="isNumber()"
                    color="primary"
                    :maxlength="4"
                    :counter="4"
                    clearable
                    dense
                    label="Complemento:"
                    :hint="'Ingrese información:'"
                    v-bind="props"
                  >
                  </v-text-field>
                </template>
                <span>Bis</span>
              </v-tooltip>
            </v-col>
            <!--Completo -->
            <v-col cols="10" sm="10" md="10">
              <v-text-field
                v-model="modelSelected.completo"
                label="Dirección Final:"
                :maxlength="300"
                :counter="300"
                readonly
                scrollable
              >
              </v-text-field>
            </v-col>
            <v-col cols="2" sm="2" md="2">
              <v-btn
                class="d-none d-md-block"
                @click="direccioncompleta()"
                color="green"
                text
                >Dirección Formateada</v-btn
              >
            </v-col>
          </v-row></v-card-text
        >
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "direcciones-modal",
  props: {
    Direccion: {
      type: String,
      default: "",
      Description: "Información de Dirección",
    },
    infoData: {
      type: Object,
      default: null,
      Description: "Información de datos guardados",
    },
  },
  data() {
    return {
      progreso: false,
      modal2: false,
      guardado: false,
      modelSelected: {
        prefijo: null,
        prefijo2: null,
        prefijo3: null,
        numero1: null,
        numero2: null,
        numero3: null,
        letra1: null,
        letra2: null,
        letra3: null,
        orientacion: null,
        orientacion2: null,
        adicional: null,
        completo: null,
      },
      dataInfo: null,
      ArrayPrefijo: [],
      ArrayBis: [],
      ArrayOrientacion: [],
    };
  },
  methods: {
    // Numeros
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    // Método de direcciones
    direccioncompleta() {
      this.modelSelected.completo = "";
      if (
        this.dataInfo.TipoViaPrincipal != "" &&
        this.dataInfo.TipoViaPrincipal != undefined &&
        this.dataInfo.TipoViaPrincipal != null
      ) {
        this.modelSelected.completo = this.dataInfo.TipoViaPrincipal;
      }
      if (
        this.dataInfo.NumeroViaPrincipal > 0 &&
        this.dataInfo.NumeroViaPrincipal != undefined &&
        this.dataInfo.NumeroViaPrincipal != null
      ) {
        this.modelSelected.completo += " " + this.dataInfo.NumeroViaPrincipal;
      }
      if (
        this.dataInfo.ModificadorViaPrincipal != "" &&
        this.dataInfo.ModificadorViaPrincipal != undefined &&
        this.dataInfo.ModificadorViaPrincipal != null
      ) {
        this.modelSelected.completo +=
          " " +
          this.dataInfo.ModificadorViaPrincipal.toUpperCase().replace(/ /g, "");
      }
      if (
        this.dataInfo.PrefijoViaPrincipal != "" &&
        this.dataInfo.PrefijoViaPrincipal != undefined &&
        this.dataInfo.PrefijoViaPrincipal != null
      ) {
        this.modelSelected.completo += " " + this.dataInfo.PrefijoViaPrincipal;
      }
      if (
        this.modelSelected.letra2 != "" &&
        this.modelSelected.letra2 != undefined &&
        this.modelSelected.letra2 != null
      ) {
        this.modelSelected.completo +=
          " " + this.modelSelected.letra2.toUpperCase().replace(/ /g, "");
      }
      if (
        this.modelSelected.orientacion != "" &&
        this.modelSelected.orientacion != undefined &&
        this.modelSelected.orientacion != null
      ) {
        this.modelSelected.completo += " " + this.modelSelected.orientacion;
      }
      if (
        this.dataInfo.NumeroVia > 0 &&
        this.dataInfo.NumeroVia != undefined &&
        this.dataInfo.NumeroVia != null
      ) {
        this.modelSelected.completo += " # " + this.dataInfo.NumeroVia;
      }
      if (
        this.dataInfo.ModificadorVia != "" &&
        this.dataInfo.ModificadorVia != undefined &&
        this.dataInfo.ModificadorVia != null
      ) {
        this.modelSelected.completo +=
          " " + this.dataInfo.ModificadorVia.toUpperCase().replace(/ /g, "");
      }
      if (
        this.dataInfo.NumeroPLaca > 0 &&
        this.dataInfo.NumeroPLaca != undefined &&
        this.dataInfo.NumeroPLaca != null
      ) {
        this.modelSelected.completo += " - " + this.dataInfo.NumeroPLaca;
      }
      if (
        this.dataInfo.PrefijoViaGeneradora != "" &&
        this.dataInfo.PrefijoViaGeneradora != undefined &&
        this.dataInfo.PrefijoViaGeneradora != null
      ) {
        this.modelSelected.completo += " " + this.dataInfo.PrefijoViaGeneradora;
      }

      // Información Adicional
      if (
        this.modelSelected.adicional != "" &&
        this.modelSelected.adicional != undefined &&
        this.modelSelected.adicional != null
      ) {
        this.modelSelected.completo += " " + this.modelSelected.adicional;
      }

      if (
        this.modelSelected.completo != null &&
        this.modelSelected.completo != "" &&
        this.modelSelected.completo != undefined
      ) {
        this.modelSelected.completo = this.modelSelected.completo
          .trim()
          .substring(0, 200);
      }
    },
    // Método Guardar
    Guardar() {
      if (
        this.modelSelected.completo != null &&
        this.modelSelected.completo != ""
      ) {
        this.$emit("update:Direccion", this.modelSelected.completo);
        this.$emit("update:infoData", this.dataInfo);
        this.modal2 = false;
        this.guardado = true;
      } else {
        this.guardado = false;
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " El campo de direcciones no contiene ningún registro, por favor revisar.",
        });
      }
    },
  },
  mounted() {
    var TablaSeleccion = this.$store.getters.MTablaSeleccion;
    this.ArrayPrefijo = TablaSeleccion.filter(
      (item) => item.Valor != null && item.TablaId == 31
    );

    this.ArrayBis = TablaSeleccion.filter(
      (item) => item.Valor != null && item.TablaId == 32
    );

    this.ArrayOrientacion = TablaSeleccion.filter(
      (item) => item.Valor != null && item.TablaId == 33
    );

    if (this.infoData) {
      this.dataInfo = this.infoData;
      this.modelSelected.completo = this.infoData.DireccionDetalle;
    }
  },
};
</script>
